module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "rt-nav"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-609fe23b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/nav/src/nav.vue
// module id = 1435
// module chunks = 116